import { SKIP_TO_CONTENT } from '../actions/skip-to-content';

const initialState = {
  userSkipToContent: false,
};

const skipToContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SKIP_TO_CONTENT:
      return {
        ...state,
        userSkipToContent: action.payload,
      };
    default:
      return state;
  }
};

export default skipToContentReducer;
